export const RAIL_PREVIEW_GAP = 12;

type RailRect = { left: number; right: number; top: number; bottom: number };

// Use the transformed coin bounds, not its unscaled 64px layout box.
export function railPreviewPosition(
  side: 'left' | 'right',
  rail: RailRect,
  coin: RailRect,
  height: number,
  scale: number,
  viewportHeight: number,
) {
  const top = Math.max(RAIL_PREVIEW_GAP, rail.top);
  const bottom = Math.min(viewportHeight - RAIL_PREVIEW_GAP, rail.bottom);
  const half = (height * scale) / 2;
  const center = Math.max(
    top + half,
    Math.min(bottom - half, (coin.top + coin.bottom) / 2),
  );
  return {
    inset:
      (side === 'right' ? rail.right - coin.left : coin.right - rail.left) +
      RAIL_PREVIEW_GAP,
    top: center - rail.top - height / 2,
  };
}

export function railPreviewMaxHeight(
  rail: Pick<RailRect, 'top' | 'bottom'>,
  viewportHeight: number,
  scale: number,
) {
  const available =
    Math.min(viewportHeight - RAIL_PREVIEW_GAP, rail.bottom) -
    Math.max(RAIL_PREVIEW_GAP, rail.top);
  // Constrain oversized animation frames, then restore the full content as it fits.
  return Math.max(0, Math.floor(available / Math.max(1, scale)));
}
